module.exports = __webpack_public_path__ + "img/yuliakopchak.ff4b045f.jpg";